import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { question } from 'react-icons-kit/fa/question'

import Matter from 'components/Matter/Matter';

import IGEAR from 'static/img/igear.svg';
import BackImage from 'static/img/banner.png';

import './Content.css';

declare var CONFIGURATIONS;

class Content extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collections: this.props.collections,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ collections: nextProps.collections });
  }

  render() {
    const { collections } = this.state;
    const mattersRows = [];
    const fullRows = [];
    collections.forEach((c, index) => {
      mattersRows.push(<Matter key={`matter_${c.name}`} title={c.title} image={c.image_display_url} type={c.name} number={index + 1} />);
    });

    for (let i = 0; i < Math.ceil(collections.length / 3); i += 1) {
      fullRows.push(
        <div key={`matterFR${i}`} className='row'>
          {mattersRows[0 + (i * 3)] !== undefined ? mattersRows[0 + (i * 3)] : null}
          {mattersRows[1 + (i * 3)] !== undefined ? mattersRows[1 + (i * 3)] : null}
          {mattersRows[2 + (i * 3)] !== undefined ? mattersRows[2 + (i * 3)] : null}
        </div>
      );
    }

    return (
      <div className='contentContainer'>
        <div className='bannerContainer' style={{ backgroundImage: `url(${BackImage})` }}></div>
        <div className='homeTextContainer'>
          <div>
            <div>
              <img src={IGEAR} alt='IGEAR'/>
            </div>
            <div dangerouslySetInnerHTML={{ __html: CONFIGURATIONS.home_text }} />
          </div>
        </div>
        <div className='mattersFullContainer'>
          <div>Colecciones cartográficas</div>
          <div className='mattersContainer'>
            { fullRows }
          </div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <div className='guideContainer' title='Manual de uso'>
              <a href={CONFIGURATIONS.guide_url} target='_blank' rel='noreferrer noopener'>
                <Icon size={'28px'} icon={question}/>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(Content);
